export default __webpack_public_path__ + "static/SupremeLL-Light-15ceec8a1adeccc5f651dbe7b29fb156.woff2";